import Factory from "@/schemas/factory";

const schema = new Factory()
    .hasId()
    .translatable()
    .sluggable()
    .hasTitle()
    .hasYearRange()
    .hasTimestamps()
    .make();

export default schema;
